<template>
  <div id="lockdownpanel" v-if="!hidden">
    <v-card v-if="editedItem">
      <v-card-title>{{editedItem.properties.id ? $t('Update') : $t('New entry')}}</v-card-title>
      <v-card-text class="pt-0 pb-0">
        <v-text-field :label="$t('Name')" v-model="editedItem.properties.name"></v-text-field>
        <v-select
          :label="$t('Type')"
          :items="translatedTypes"
          item-text="label"
          item-value="value"
          v-model="editedItem.properties.type"
        ></v-select>
        <v-text-field :label="$t('Remark')" v-model="editedItem.properties.description"></v-text-field>
        <v-text-field
          :label="$t('Beginning of restriction')"
          v-model="editedItem.properties.dateFrom"
          prepend-icon="date_range"
          :hint="$t('Format: 15/03/2020 8:10:20')"
          :rules="[this.rules.isDate, this.rules.required]"
          @blur="formatDate(editedItem.properties,'dateFrom')"
          persistent-hint
        ></v-text-field>
        <v-text-field
          :label="$t('End of restriction')"
          v-model="editedItem.properties.dateTo"
          prepend-icon="date_range"
          :hint="$t('Format: 15/03/2020 8:10:20')"
          :rules="[this.rules.isDate, this.rules.required]"
          @blur="formatDate(editedItem.properties,'dateTo')"
          persistent-hint
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn small @click="exit">{{$t('Cancel')}}</v-btn>
        <v-btn small color="primary" @click="save">{{$t('Save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<style lang="scss" scoped>
@import "./LockdownDetailsEditor.scss";
</style>

<script>
import moment from "moment-mini";
import { mapState } from "vuex";
import { formatDate, getDateTimeFormat } from "../helpers/dateFormat";
import { translateLabel } from "../helpers/dataTranslations";

export default {
  name: "LockdownDetailsEditor",

  data() {
    return {
      jsonschemaFormOption: {
        debug: false,
        disableAll: false,
        autoFoldObjects: true
      },
      hidden: true,
      types: [],
      deafultType: "",
      propertiesSchema: {
        required: ["type", "dateFrom", "dateTo"],
        type: "object",
        properties: {
          name: {
            title: "Név",
            type: "string"
          },
          type: {
            title: "Típus",
            type: "object",
            enum: [
              { label: "Ez", value: "ez" },
              { label: "Az", value: "az" }
            ],
            "x-itemTitle": "label",
            "x-itemValue": "value"
          },
          description: {
            title: "Megjegyzés",
            type: "string"
          },
          dateFrom: {
            title: "Lezárás kezdete",
            type: "string",
            format: "date"
          },
          dateTo: {
            title: "Lezárás vége",
            type: "string",
            format: "date"
          }
        }
      },
      formatDate: formatDate,
      editedItem: undefined,
      keyForForce: 0,
      rules: {
        required: value => !!value || this.$t("This field is required!"),
        isDate: value =>
          !value ||
          moment(value, getDateTimeFormat()).isValid() ||
          `${this.$t('The specified format is incorrect!')} ${this.$t('Format: 15/03/2020 8:10:20')}`
      }
    };
  },

  watch: {
    config(config) {
      if (config) {
        this.types = this.config.lockdownTypes;
      }
    }
  },

  mounted() {
    if (this.config) {
      this.types = this.config.lockdownTypes;
      for (let type of this.types) {
        if (type.default) {
          this.deafultType = type.value;
          break;
        }
      }
    }
  },

  computed: {
    ...mapState({
      config: state => state.app.config
    }),
    translatedTypes() {
      return translateLabel(this.types)
    },
  },

  methods: {
    refresh(item) {
      this.prepareEditedItem(item);
      this.keyForForce++;
    },
    prepareEditedItem(item) {
      if (item) {
        this.editedItem = { ...item };
        formatDate(this.editedItem.properties, "dateTo");
        formatDate(this.editedItem.properties, "dateFrom");
        if (!this.editedItem.properties.type) {
          this.editedItem.properties.type = this.deafultType;
        }
      } else {
        this.editedItem = item;
      }
    },
    exit() {
      this.editedItem = undefined;
      this.$parent.clearSelectedPoygon();
    },
    async save() {
      if (this.editedItem.properties.id) {
        await this.$parent.polygonUpdated(this.editedItem);
      } else {
        await this.$parent.polygonCreated(this.editedItem);
      }
      this.editedItem = undefined;
    },
    show() {
      this.hidden = false;
    },
    hide() {
      this.hidden = true;
    }
  }
};
</script>
